import styled from 'styled-components'
import IntroSeasons from '../IntroSeasons'
import PlantInfo from '../PlantInfo'
import useScrollStore from '../useScrollStore'
import { useEffect, useState } from 'react'

export const Overlay = () => {
  const [show, setShow] = useState(false)

  useEffect(() => {
    const unsubscribe = useScrollStore.subscribe((state) => {
      const shouldBeShown = state.scrollPct >= 0.05 && state.scrollPct < 0.9
      if (show !== shouldBeShown) {
        setShow(shouldBeShown)
      }
    })

    return () => unsubscribe()
  }, [show])

  return (
    <Container show={show}>
      <SeasonsCalendarContainer>
        <IntroSeasons />
      </SeasonsCalendarContainer>
      <PlantInfo
        place='Versoix, GE'
        name='Marronnier'
        scientificName='Aesculus hippocastanum'
      />
    </Container>
  )
}

const Container = styled.div<{ show: boolean }>`
  position: absolute;
  width: 100%;
  height: 100vh;
  z-index: 1;
  opacity: ${({ show }) => (show ? 1 : 0)};
  transition: opacity 1s ease-in-out;
  pointer-events: none;
`

const SeasonsCalendarContainer = styled.div`
  position: absolute;
  top: 2vh;
  left: 50%;
  max-width: 600px;
  width: 100%;
  transform: translateX(-50%);

  ${({ theme }) => theme.breakpoints.down('md')} {
    top: 10vh;
  }
`
